<template>
  <div class="inject-page-host" style="width:100%;height:100%;min-height:400px;"></div>
</template>

<script>
export default {
  name: 'DigitalSite',
  mounted() {
    const el = this.$el
    this.$nextTick(() => {
      if (window.DAP_mount) window.DAP_mount(el)
    })
  },
  beforeDestroy() {
    if (window.DAP_destroy) window.DAP_destroy()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/DigitalSite/index.vue